import { useMemo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { Wrapper } from '@screentone/core';

import { CommonEntityProps } from 'components/datamodel/commonEntityProps';
// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { useDataModelContext } from 'contexts/datamodel/useDataModel';
import { DROPPABLE_ID_PREFIXES, DROPPABLE_TYPES } from 'contexts/drag-and-drop/dragUtils';
// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { usePageTypeSettingsContext } from 'contexts/page-type-settings/usePageTypeSettings';
import { NewsletterPageContainer } from 'data/generated/graphql';
import styles from './Newsletter.module.scss';

import { EntityType } from 'contexts/datamodel/DataModelContext.constants';

interface NewsletterProps extends CommonEntityProps {
  data: NewsletterPageContainer;
}

const Newsletter = ({ data, parentHierarchyId, index, withoutDragNDrop }: NewsletterProps) => {
  const { generateHierarchyId, renderEntity } = useDataModelContext();
  const { currentLayout } = usePageTypeSettingsContext();

  const hierarchyId = generateHierarchyId(data, parentHierarchyId, index);

  const hasGroupAsChildren = useMemo(
    () => data.collection.some((item) => item.type === EntityType.Group),
    [data.collection]
  );

  if (!currentLayout) return null;

  const padding = hasGroupAsChildren ? {} : { top: 'sm', right: 'md', bottom: 'md', left: 'md' };

  const childrenElements = data.collection.map((collection, i) => (
    <div key={i}>
      {renderEntity(collection, {
        hierarchyId,
        index: i,
        isHistory: false,
        extraProps: {
          module: {
            layout: currentLayout
          }
        },
        withoutDragNDrop: (withoutDragNDrop ?? false) || data.collection.length === 1
      })}
    </div>
  ));

  return (
    <Wrapper padding={padding} className={styles.newsletterWrapper} data-model-hierarchy-id={hierarchyId}>
      {!hasGroupAsChildren && <Wrapper className={styles.newsletterBackground} />}
      {!withoutDragNDrop ? (
        <Droppable droppableId={DROPPABLE_ID_PREFIXES.NEWSLETTER + hierarchyId} type={DROPPABLE_TYPES.MODULE}>
          {(droppableProvided) => (
            <div
              ref={droppableProvided.innerRef}
              {...droppableProvided.droppableProps}
              data-testid="newsletter-draft-modules"
            >
              {childrenElements}
              {droppableProvided.placeholder}
            </div>
          )}
        </Droppable>
      ) : (
        <>{childrenElements}</>
      )}
    </Wrapper>
  );
};

export default Newsletter;
